<template>
  <DropDownFilter
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    storeModule="SoftwareAppsCollection"
  />
</template>

<script>
import * as Constants from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import AppleSoftwareManagementFilterMixin from 'client/components/ItemTable/mixins/AppleSoftwareManagementFilterMixin';
import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';

const {
  ItemTypeConsts,
  StoreModuleMap,
} = Constants;
const softwareAppsCollection = StoreModuleMap[ItemTypeConsts.softwareApps];

export default {
  name: 'AppleSoftwareManagementDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    AppleSoftwareManagementFilterMixin,
    DropDownFilterMixin,
  ],

  data: () => ({
    SoftwareAppsCollection: softwareAppsCollection,
  }),

  computed: {
    // mapped getters used in DropDownFilterMixin
    ...mapGetters(softwareAppsCollection, [
      'getFilters',
    ]),
  },

  methods: {
    // mapped actions used in DropDownFilterMixin
    ...mapActions(softwareAppsCollection, [
      'fetchCollection',
      'setFilter',
      'setFilters',
    ]),
  },
};
</script>
